<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton"></rappider-title-toolbar>

<section>
  <rappider-crud-view-edit-form [config]="PROJECT_DOCUMENT_EDIT_CONFIG"
                                [data]="projectDocument"
                                [submitButtonLoading]="loading"
                                (formSubmit)="onUpdateProjectDocument($event)"></rappider-crud-view-edit-form>
</section>